export const legal = {
  termsTitle: 'Terms of Use',
  privacyTitle: 'Privacy Policy',
};
